import { create } from 'zustand'
import { useStorageStore } from './storage'

export interface GalleryItem {
  id: string
  imageUrl: string
  nodeLabel: string
  providerId: string
  model: string
  timestamp: string
}

interface GalleryStore {
  items: GalleryItem[]
  addItem: (item: Omit<GalleryItem, 'id' | 'timestamp'>) => void
  clear: () => void
}

export const useGalleryStore = create<GalleryStore>()((set) => ({
  items: [],

  addItem: ({ imageUrl, nodeLabel, providerId, model }) => {
    set((s) => ({
      items: [
        {
          id: crypto.randomUUID(),
          imageUrl,
          nodeLabel,
          providerId,
          model,
          timestamp: new Date().toISOString(),
        },
        ...s.items,
      ],
    }))
    // Fire-and-forget: storage failures never block the session gallery
    useStorageStore.getState().saveToAll(imageUrl, model)
  },

  clear: () => set({ items: [] }),
}))
